import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import NotificationIcon from '../../../../components/icons/NotificationIcon';
import StatusCounter from './components/StatusCounter';

const propTypes = {
  notificationIconColor: PropTypes.string,
  count: PropTypes.number.isRequired,
  Icon: PropTypes.func,
};

const NotificationCounter = ({
  count,
  notificationIconColor,
  Icon = NotificationIcon,
  className,
  ...props
}) => {
  const hasItems = count > 0;
  // Default to separate colours for 0 and 1+, or use overloaded colour for both.
  const notificationIconColour = hasItems
    ? notificationIconColor ?? '#646e71'
    : notificationIconColor ?? '#8c9699';

  const classes = classNames({
    'notification-counter': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <Icon color={notificationIconColour} {...props} />
      {hasItems && (
        <StatusCounter className="notification-counter-count" count={count} />
      )}
    </div>
  );
};

NotificationCounter.propTypes = propTypes;

export default NotificationCounter;
